<template>
  <div>
    <UserPageActions>
      <div
        class="d-flex align-items-center flex-wrap justify-content-between w-100"
      >
        <div class="d-flex flex-column w-100">
          <Card class="mb-3">
            <template #content>
              <div class="mb-2" style="width: 300px">
                <Dropdown
                  v-model="selectedUserType"
                  :options="userTypeOptions"
                  option-value="value"
                  option-label="label"
                  class="w-100"
                />
              </div>
              <SelectButton
                v-if="selectedUserType === 'normal'"
                v-model="selectedUserSpecialTypes"
                :options="userSpecialTypeOptions"
                option-value="value"
                option-label="label"
                multiple
                class="mb-2"
              />
            </template>
          </Card>

          <Card class="w-100">
            <template #content>
              <div class="d-flex align-items-start flex-wrap py-2">
                <div style="width: 400px; max-width: 100%" class="me-2">
                  <div class="">
                    <FormLabel label="組織フィルター" />
                    <Dropdown
                      v-model="selectedOrganizationType"
                      :options="organizationTypeOptions"
                      option-value="value"
                      option-label="label"
                    />
                  </div>

                  <div
                    v-if="selectedOrganizationType === 'branch'"
                    class="mt-2 me-2"
                  >
                    <SelectButton
                      v-model="selectedBranchIds"
                      :options="branchOrganizations"
                      option-value="id"
                      option-label="name"
                      multiple
                    />
                    <div class="d-flex align-items-center mt-1">
                      <BasicButton
                        label="全選択"
                        variant="secondary"
                        icon="pi pi-check"
                        outlined
                        class="me-1"
                        @click="
                          selectedBranchIds = branchOrganizations.map(
                            (b) => b.id
                          )
                        "
                      />
                      <BasicButton
                        label="全解除"
                        variant="secondary"
                        outlined
                        icon="pi pi-times"
                        @click="selectedBranchIds = []"
                      />
                    </div>
                  </div>

                  <div
                    v-if="selectedOrganizationType === 'committee'"
                    class="me-2"
                  >
                    <SelectButton
                      v-model="selectedCommitteeIds"
                      :options="committeeOrganizations"
                      option-value="id"
                      option-label="name"
                      multiple
                    />
                    <div class="d-flex align-items-center mt-1">
                      <BasicButton
                        label="全選択"
                        variant="secondary"
                        outlined
                        class="me-1"
                        @click="
                          selectedCommitteeIds = committeeOrganizations.map(
                            (c) => c.id
                          )
                        "
                      />
                      <BasicButton
                        label="全解除"
                        variant="secondary"
                        outlined
                        icon="pi pi-times"
                        @click="selectedCommitteeIds = []"
                      />
                    </div>
                  </div>
                </div>
                <div style="width: 400px; max-width: 100%">
                  <div>
                    <FormLabel label="役職・権限フィルター" />
                    <Dropdown
                      v-model="selectedPermissionType"
                      :options="permissionTypeOptions"
                      option-value="value"
                      option-label="label"
                    />
                  </div>

                  <div
                    v-if="selectedPermissionType === 'position'"
                    class="mt-2"
                  >
                    <SelectButton
                      v-model="selectedPositionTypes"
                      :options="
                        positionTypesByOrganizationType[
                          selectedOrganizationType
                        ]
                      "
                      :option-label="userPositionTranslater"
                      multiple
                    />
                    <div class="d-flex align-items-center mt-1">
                      <BasicButton
                        label="全選択"
                        variant="secondary"
                        outlined
                        icon="pi pi-check"
                        class="me-1"
                        @click="
                          selectedPositionTypes =
                            positionTypesByOrganizationType[
                              selectedOrganizationType
                            ]
                        "
                      />
                      <BasicButton
                        label="全解除"
                        variant="secondary"
                        outlined
                        icon="pi pi-times"
                        @click="selectedPositionTypes = []"
                      />
                    </div>
                  </div>

                  <div v-if="selectedPermissionType === 'label'" class="mt-2">
                    <SelectButton
                      v-model="selectedLabelTypes"
                      :options="
                        labelTypesByOrganizationType[selectedOrganizationType]
                      "
                      :option-label="userLabelTranslater"
                      multiple
                    />
                    <div class="d-flex align-items-center">
                      <BasicButton
                        label="全選択"
                        variant="secondary"
                        outlined
                        class="me-1"
                        @click="
                          selectedLabelTypes =
                            labelTypesByOrganizationType[
                              selectedOrganizationType
                            ]
                        "
                      />
                      <BasicButton
                        label="全解除"
                        variant="secondary"
                        outlined
                        @click="selectedLabelTypes = []"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </Card>
        </div>
      </div>
    </UserPageActions>

    <Card>
      <template #content>
        <div class="d-flex justify-content-end mt-2">
          <div class="d-flex justify-content-end">
            <BasicButton
              v-if="isOffice"
              label="追加"
              icon="pi pi-plus"
              variant="secondary"
              outlined
              @click="
                goto({
                  name: 'UsersNew',
                })
              "
            />
          </div>
        </div>

        <i v-if="!users" class="pi pi-spinner pi-spinner"></i>
        <DataTable
          v-else
          v-model:selection="selectedUsers"
          striped-rows
          paginator
          lazy
          :rows="selectedPerPage"
          :total-records="totalUsers"
          :value="filteredUsers"
          table-style="width: 100%"
          :selection-mode="selectionMode"
          scrollable
          scroll-height="60vh"
          @page="onPage"
          @row-click="({ data }) => selectUserForShow({ data })"
        >
          <template #header>
            <div class="d-flex justify-content-between">
              <!--
          <div
            v-if="selectedItems.length"
            class="table-action-menu-button-wrapper"
          >
            <MenuButton :menu-items="menuItems" />
          </div>
          -->
              <div class="d-flex align-items-center">
                <div class="d-flex flex-column me-4">
                  <InputForm
                    v-model:value="searchName"
                    class="w-100"
                    is-valid
                    icon="pi pi-search"
                    placeholder="名前検索"
                  />
                </div>

                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center">
                    <BasicButton
                      v-if="isOwner && !!selectionMode"
                      label="キャンセル"
                      icon="pi pi-times"
                      class="me-2"
                      variant="secondary"
                      text
                      outlined
                      @click="selectionMode = undefined"
                    />
                    <BasicButton
                      v-if="isOwner"
                      :label="!selectionMode ? 'CSV' : '決定'"
                      icon="pi pi-download"
                      class="me-2"
                      text
                      outlined
                      @click="
                        !selectionMode
                          ? startCsvMemberSelect()
                          : openCsvDialog()
                      "
                    />
                    <span
                      v-if="selectionMode === 'multiple'"
                      style="font-size: 0.7rem"
                    >
                      メンバーを選択して下さい
                    </span>
                  </div>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div
                  class="d-flex justify-content-between align-items-center me-3"
                >
                  <div>
                    <span>{{ totalUsers }} 人</span>
                  </div>
                </div>

                <TableHeader
                  v-model="selectedPerPage"
                  :total-pages="totalPages"
                  :current-page="currentPage"
                  :per-page-options="[20, 50, 100, 200, 500]"
                  @update:model-value="currentPage = 1"
                />
              </div>
            </div>
          </template>
          <Column
            v-if="selectionMode && (isOffice || isUserManager || isAManager)"
            :selectionMode="selectionMode"
            headerStyle="min-width: 2rem"
          ></Column>
          <Column
            :field="(user: UserClient) => user.lastName + user.firstName"
            header="名前"
            :style="{ 'min-width': '150px' }"
          >
            <template #body="slotProps">
              <span>{{
                slotProps.data.lastName + slotProps.data.firstName
              }}</span>
              <span
                v-if="slotProps.data.confirmedInWeek"
                class="text-danger ms-1 rotate-45"
              >
                NEW
              </span>
              <span
                v-if="isOwner && slotProps.data.updatedInWeek"
                class="text-green ms-1 rotate-45"
              >
                UPDATE
              </span>
            </template>
          </Column>
          <Column
            v-if="false"
            field="beforeCheckManager"
            header="承認"
            style="width: 100px"
          >
            <template #body="slotProps">
              <i
                v-if="slotProps.data.beforeCheckManager"
                class="pi pi-minus text-danger"
              ></i>
              <i v-else class="pi pi-check text-success"></i>
            </template>
          </Column>
          <Column field="special" header="特別会員" style="min-width: 120px">
            <template #body="slotProps">
              <i
                v-if="slotProps.data.special"
                class="pi pi-check text-success"
              ></i>
            </template>
          </Column>
          <Column
            v-if="isOffice"
            field="deposited"
            header="口振"
            style="min-width: 80px"
          >
            <template #body="slotProps">
              <i
                v-if="
                  slotProps.data.beforeCheckManager && !slotProps.data.deposited
                "
                class="pi pi-minus text-danger"
              ></i>
              <i v-else class="pi pi-check text-success"></i>
            </template>
          </Column>
          <Column
            field="email"
            header="メール"
            :style="{ 'min-width': '200px' }"
          />
          <Column
            :field="
              (user) =>
                user.organizations.filter((o) => o.branch).length
                  ? user.organizations
                      .filter((o) => o.branch)
                      .map((o) => o.name)
                      .join(',')
                  : '-'
            "
            header="支部"
            :style="{ 'min-width': '120px' }"
          />
          <Column
            :field="
              (user) =>
                user.organizations.filter(
                  (o) => o.name !== '県協会' && !o.branch
                ).length
                  ? user.organizations
                      .filter((o) => o.name !== '県協会' && !o.branch)
                      .map((o) => o.name)
                      .join(',')
                  : '-'
            "
            header="委員会"
            :style="{ 'min-width': '200px' }"
          />
          <Column
            :field="
          (user: UserClient) =>
            user.userPositions.length
              ? user.userPositions
                  .map((up) => userPositionTranslater(up.positionType))
                  .join(',')
              : '-'
        "
            header="役職"
            :style="{ 'min-width': '200px' }"
          />
          <Column
            :field="
              (user) =>
                user.userLabels
                  .map(
                    (ul) =>
                      `${
                        ul.dependancyName && ul.dependancyName !== '県協会'
                          ? `${ul.dependancyName} `
                          : ''
                      }${userLabelTranslater(ul.labelType)}`
                  )
                  .join(',')
            "
            header="権限"
            style="min-width: 200px"
          />
          <Column
            v-if="isOffice"
            field="confirmedAt"
            header="登録日"
            :style="{ width: '160px', 'min-width': '160px' }"
          >
            <template #body="{ data }">
              <div v-if="data.confirmedAt" class="d-flex align-items-center">
                <span class="text-end">{{
                  basicFormatter(data.confirmedAt, "slashStyleOnlyDateWithZero")
                }}</span>
              </div>
              <span v-else class="text-danger">メール未認証</span>
            </template>
          </Column>
          <Column
            v-if="isOffice"
            field="unsubscribedAt"
            header="退会済"
            style="min-width: 130px"
          >
            <template #body="slotProps">
              <span v-if="slotProps.data.unsubscribedAt">
                {{
                  basicFormatter(
                    slotProps.data.unsubscribedAt,
                    "slashStyleOnlyDateWithZero"
                  )
                }}
              </span>
            </template>
          </Column>
        </DataTable>
      </template>
    </Card>

    <Dialog
      v-model:visible="visibleShowDialog"
      modal
      :header="
        selectedUser ? selectedUser.lastName + selectedUser.firstName : ''
      "
      dismissable-mask
      block-scroll
      style="width: 90%; max-width: 800px"
      @after-hide="closeShowDialog"
    >
      <div v-if="selectedUser" class="p-2">
        <UserShow :user="selectedUser" />
        <div class="d-flex justify-content-end">
          <BasicButton
            label="閉じる"
            variant="secondary"
            class="me-2"
            outlined
            @click="closeShowDialog"
          />
          <BasicButton label="編集" class="ms-2" @click="selectUser" />
        </div>
      </div>
    </Dialog>

    <Dialog
      v-model:visible="visible"
      modal
      :header="
        selectedUser ? selectedUser.lastName + selectedUser.firstName : ''
      "
      dismissable-mask
      block-scroll
      style="width: 90%; max-width: 800px"
      @after-hide="closeDialog"
    >
      <div v-if="selectedUser" class="p-2">
        <TabView>
          <TabPanel header="基本情報">
            <template v-if="selectedUser.beforeCheckManager">
              <div class="mb-3 text-danger">
                <span v-if="selectedUser.beforeCheckManager">
                  承認前の会員です
                </span>
              </div>
              <UserShow :user="selectedUser" />
            </template>
            <template v-else-if="isUserManager || isOffice">
              <FormLabel label="会員情報" class="me-2" />
              <UserForm
                v-model:special="form.special"
                v-model:last-name="form.lastName"
                v-model:first-name="form.firstName"
                v-model:last-name-kana="form.lastNameKana"
                v-model:first-name-kana="form.firstNameKana"
                v-model:email="form.email"
                v-model:birthday="form.birthday"
                v-model:phone-number="form.phoneNumber"
                v-model:postcode="form.postcode"
                v-model:address="form.address"
                v-model:have-affiliation="form.haveAffiliation"
                v-model:affiliation="form.affiliation"
                v-model:affiliation-phone-number="form.affiliationPhoneNumber"
                v-model:affiliation-postcode="form.affiliationPostcode"
                v-model:affiliation-address="form.affiliationAddress"
                v-model:business="form.business"
                v-model:registration-number="form.registrationNumber"
                :email-check="form.email"
                :errors="errors"
                :organizations="[]"
                :organization-members="[]"
                hide-email-check
              />
            </template>
            <template v-else-if="isOffice">
              <div class="mb-3 text-danger">
                <span v-if="selectedUser.beforeCheckManager"
                  >認証前の会員です</span
                >
                <span v-else>認証済みです</span>
              </div>

              <FormLabel label="会員情報" class="me-2" />
              <UserShow :user="selectedUser" />
            </template>
          </TabPanel>
          <TabPanel header="所属組織/役職/権限">
            <template
              v-if="
                !selectedUser.beforeCheckManager &&
                (isAllLManager || isABCManager)
              "
            >
              <template v-for="ot in organizationTypeOptions" :key="ot.value">
                <div
                  v-for="(om, idx) in form.organizationMembers.filter(
                    (om) => ot.value === om.type
                  )"
                  :key="om.organizationId"
                  class="card card-body mb-3"
                >
                  <div class="mb-2">
                    <template v-if="ot.value !== 'all'">
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <FormLabel
                          :label="`${
                            ot.value === 'branch' ? '支部' : '委員会'
                          }`"
                          without-padding
                        />
                        <BasicButton
                          icon="pi pi-trash"
                          variant="danger"
                          :disabled="
                            !!om.id &&
                            om.organizationId === associationOrganizationId
                          "
                          text
                          @click="deleteOrganizationMember(idx, om.type)"
                        />
                      </div>

                      <Dropdown
                        v-model="om.organizationId"
                        :options="
                          organizations?.filter(
                            (o) => organizationTypeMap[o.id] === ot.value
                          )
                        "
                        option-label="name"
                        option-value="id"
                        class="w-100"
                        :disabled="
                          !!om.id &&
                          om.organizationId === associationOrganizationId
                        "
                      />
                    </template>
                    <FormLabel v-else label="県協会" without-padding />
                  </div>

                  <div
                    v-if="
                      !form.userPositions.filter(
                        (up) => up.organizationId === om.organizationId
                      ).length
                    "
                    class="d-flex align-items-center mb-2"
                  >
                    <BasicButton
                      icon="pi pi-plus"
                      label="役職"
                      :disabled="
                        disabledAddPosition(om.organizationId, om.type)
                      "
                      text
                      outlined
                      @click="addPosition(om.organizationId)"
                    />
                  </div>
                  <div v-else class="">
                    <div class="d-flex align-items-center">
                      <FormLabel label="役職" without-padding />
                      <BasicButton
                        icon="pi pi-plus"
                        :disabled="disabledAddPosition(om.organizationId)"
                        text
                        @click="addPosition(om.organizationId)"
                      />
                    </div>
                  </div>

                  <template
                    v-for="(up, idx) in form.userPositions"
                    :key="up.positionType"
                  >
                    <template v-if="up.organizationId === om.organizationId">
                      <div
                        class="d-flex align-items-center mb-2"
                        :class="{
                          'mt-2': idx !== 0,
                        }"
                      >
                        <Dropdown
                          v-model="up.positionType"
                          :options="
                            selectablePositionTypesMap[
                              organizationTypeMap[om.organizationId]
                            ]
                          "
                          :option-label="userPositionTranslater"
                          class="w-100"
                        />
                        <BasicButton
                          icon="pi pi-trash"
                          variant="danger"
                          text
                          bordered
                          @click="deletePosition(idx, om.organizationId)"
                        />
                      </div>
                    </template>
                  </template>

                  <div
                    v-if="
                      !form.userLabels.filter(
                        (ul) => ul.dependancyId === om.organizationId
                      ).length
                    "
                    class="d-flex align-items-center"
                  >
                    <BasicButton
                      icon="pi pi-plus"
                      label="権限"
                      :disabled="disabledAddRole(om.organizationId)"
                      text
                      outlined
                      @click="addRole(om.organizationId)"
                    />
                  </div>
                  <div v-else>
                    <div class="d-flex align-items-center">
                      <FormLabel label="権限" without-padding />
                      <BasicButton
                        icon="pi pi-plus"
                        :disabled="disabledAddRole(om.organizationId)"
                        text
                        @click="addRole(om.organizationId)"
                      />
                    </div>

                    <template
                      v-for="(ul, idx) in form.userLabels"
                      :key="ul.labelType"
                    >
                      <div v-if="ul.dependancyId === om.organizationId">
                        <div
                          class="d-flex align-items-center justify-content-between"
                          :class="{
                            'mt-2': idx !== 0,
                          }"
                        >
                          <Dropdown
                            v-model="ul.labelType"
                            :options="
                              selectableLabelTypesMap[
                                organizationTypeMap[om.organizationId]
                              ]
                            "
                            :option-label="userLabelTranslater"
                            class="w-100"
                            @update:model-value="
                              updateLabelType(ul, $event, om.organizationId)
                            "
                          />
                          <BasicButton
                            icon="pi pi-trash"
                            variant="danger"
                            text
                            class="h-100"
                            @click="deleteRole(idx, om.organizationId)"
                          />
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div
                  v-if="
                    ot.value !== 'all' &&
                    form.organizationMembers.filter(
                      (om) => ot.value === om.type
                    )
                  "
                  class="d-flex align-items-center mb-3"
                >
                  <BasicButton
                    icon="pi pi-plus"
                    :label="`所属${ot.value === 'branch' ? '支部' : '委員会'}`"
                    :disabled="disabledAddOrganizationMember"
                    text
                    outlined
                    @click="addOrganizationMember(ot.value)"
                  />
                </div>
              </template>
            </template>
          </TabPanel>
        </TabView>

        <div class="my-5">
          <div
            v-if="selectedUser.beforeCheckManager"
            class="mb-2 d-flex flex-column"
          >
            <div class="mb-3">
              <span>
                口座振替を確認次第承認して下さい。会員を承認しますか？
              </span>
            </div>
            <div>
              <BasicButton
                label="キャンセル"
                variant="secondary"
                class="me-2"
                outlined
                @click="closeDialog"
              />
              <BasicButton
                button-type="submit"
                label="承認"
                class="ms-2"
                @click="accept"
              />
            </div>
          </div>
          <template v-else>
            <div v-if="hasSame" class="text-danger mb-2">
              同様の権限か組織が存在します
            </div>
            <div
              v-if="isUserManager || isAllLManager || isABCManager"
              class="d-flex justify-content-between"
            >
              <div class="d-flex aling-items-center">
                <BasicButton
                  v-if="isDManager"
                  variant="danger"
                  :label="
                    selectedUser.unsubscribedAt ? '退会のキャンセル' : '退会'
                  "
                  class="me-2"
                  icon="pi pi-sign-out"
                  @click="
                    selectedUser.unsubscribedAt
                      ? cancelUnsubscribed()
                      : unsubscribed()
                  "
                />
                <BasicButton
                  v-if="isDManager && false"
                  variant="danger"
                  label="完全削除"
                  class="ms-2"
                  @click="() => {}"
                />
              </div>

              <div class="d-flex aling-items-center">
                <BasicButton
                  label="キャンセル"
                  variant="secondary"
                  class="me-2"
                  outlined
                  icon="pi pi-times"
                  @click="closeDialog"
                />
                <BasicButton
                  button-type="submit"
                  label="送信"
                  class="ms-2"
                  icon="pi pi-upload"
                  :disabled="hasSame || cannotSubmit"
                  @click="submit"
                />
              </div>
            </div>
          </template>
        </div>
      </div>
    </Dialog>

    <Dialog
      v-model:visible="visibleCsvDialog"
      modal
      header="出力する情報の選択"
      dismissable-mask
      block-scroll
      style="width: 90%; max-width: 800px"
      @after-hide="closeCsvDialog"
    >
      <div class="mb-3">
        <span>{{ selectedCsvInfoOptions.length }}件選択中</span>
      </div>
      <DataTable
        v-model:selection="selectedCsvInfoOptions"
        striped-rows
        :value="csvInfoOptions"
        table-style="width: 100%"
        selection-mode="multiple"
        scrollable
        scroll-height="60vh"
        class="mb-3"
        @page="onPage"
        @row-click="selectCsvInfo($event.data)"
      >
        <Column headerStyle="min-width: 2rem">
          <template #header>
            <Checkbox
              :modelValue="allSelected"
              binary
              :indeterminate="isIndeterminate"
              @change="toggleSelectAll"
            />
          </template>
          <template #body="{ data }">
            <Checkbox
              v-model="selectedCsvInfoOptions"
              :value="data"
              :disabled="data.label === '名前'"
            />
          </template>
        </Column>
        <Column header="出力する情報" :style="{ 'min-width': '150px' }">
          <template #body="{ data }">
            <span>{{ data.label }}</span>
          </template>
        </Column>
      </DataTable>

      <div class="d-flex align-items-center justify-content-end">
        <BasicButton label="ダウンロード" class="me-2" @click="downloadCsv" />
      </div>
    </Dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import { basicFormatter } from "/@/modules/luxon";
import {
  gKana,
  gPhoneNumber,
  gPostcode,
  gRegistrationNumber,
} from "/@/modules/groomer";
import { userLabelTranslater, userPositionTranslater } from "/@/modules/user";
import {
  useRouterUtil,
  useUser,
  useSystemAdmin,
  useOrganizations,
  useZodScheme,
  useTableHeader,
} from "/@/vue/composables";
import {
  Label as FormLabel,
  BasicButton,
  InputForm,
} from "/@/vue/components/Atom";
import { UserPageActions } from "/@/vue/components/Layouts";
import { Header as TableHeader } from "/@/vue/components/Molecules/TableUtils";
import { Show as UserShow } from "/@/vue/components/Molecules/Users";
import { Form as UserForm } from "/@/vue/components/Organisms/Users";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import Card from "primevue/card";
import Checkbox from "primevue/checkbox";
import SelectButton from "primevue/selectbutton";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import {
  UserClient,
  ManageUserCheckScheme,
  ManageUserForm,
  UserLabel,
  OrganizationMember,
  UserPositionType,
  UserLabelType,
  csvInfoOptions,
  CsvInfoOption,
  userTypeOptions,
  UserType,
  userSpecialTypeOptions,
  UserSpecialType,
  organizationTypeOptions,
  OrganizationType,
  permissionTypeOptions,
  PermissionType,
} from "/@/types";

const { goto } = useRouterUtil();

const {
  getUser,
  isOwner,
  isOffice,
  isUserManager,
  isAllLManager,
  isAManager,
  isBManager,
  isCManager,
  isABCManager,
  isDManager,
} = useUser();
const { data: user } = getUser();

// table header

const { currentPage, selectedPerPage } = useTableHeader();

// filter

const searchName = ref("");
const selectedUserType = ref<UserType>("normal");
const selectedUserSpecialTypes = ref<UserSpecialType[]>(["regular", "special"]);
const selectedOrganizationType = ref<OrganizationType>("all");
const selectedBranchIds = ref<number[]>([]);
const selectedCommitteeIds = ref<number[]>([]);
const selectedPermissionType = ref<PermissionType>("all");
const selectedPositionTypes = ref<UserPositionType[]>([]);
const selectedLabelTypes = ref<UserLabelType[]>([]);

// users

const { getAllUsers, updateUser, getAllUsersCSV } = useSystemAdmin();
const { data: users, mutate: getAllUsersMutate } = getAllUsers(
  currentPage,
  selectedPerPage,
  searchName,
  selectedUserType,
  selectedUserSpecialTypes,
  selectedOrganizationType,
  selectedBranchIds,
  selectedCommitteeIds,
  selectedPermissionType,
  selectedPositionTypes,
  selectedLabelTypes,
  {
    withoutAutoJoin: true,
  }
);

const usersList = computed(() => users.value?.items || []);
const totalUsers = computed(() => users.value?.totalCount || 0);
const totalPages = computed(() => users.value?.totalPages || 0);
/*
const totalPages = computed(() =>
  Math.ceil(filteredUsers.value.length / selectedPerPage.value)
);
*/

const selectedUsers = ref<UserClient[]>([]);

// table

const visibleShowDialog = ref(false);
const visible = ref(false);
const selectedUser = ref<UserClient | null>();

function selectUserForShow(event: { data: UserClient }) {
  if (selectionMode.value) {
    return;
  }

  // event.originalEvent.preventDefault();
  // event.originalEvent.stopPropagation();

  visibleShowDialog.value = true;
  selectedUser.value = event.data;
}

function closeShowDialog() {
  visibleShowDialog.value = false;
  // selectedUser.value = null;
}

function selectUser() {
  if (selectionMode.value) {
    return;
  }

  if (!selectedUser.value) {
    return;
  }

  // event.originalEvent.preventDefault();
  // event.originalEvent.stopPropagation();

  visible.value = true;
  visibleShowDialog.value = false;

  form.userLabels = [...selectedUser.value.userLabels];
}

function closeDialog() {
  visible.value = false;
  selectedUser.value = null;
}

// position

const organizationTypeMap = computed<Record<number, OrganizationType>>(() => {
  let m: Record<number, OrganizationType> = {};

  if (!organizations.value) {
    return m;
  }

  organizations.value.forEach((o) => {
    m[o.id] = o.branch ? "branch" : o.committee ? "committee" : "all";
  });

  return m;
});

const selectablePositionTypesMap = computed<
  Record<OrganizationType, UserPositionType[]>
>(() => {
  const canSelectAssociation = isAllLManager.value || isAManager;
  const canSelectBranch = isAllLManager.value || isBManager;
  const canSelectCommittee = isAllLManager.value || isCManager;

  return {
    all: canSelectAssociation
      ? ["senior_advisor", "chairman", "vice_chairman", "director", "advisor"]
      : [],
    branch: canSelectBranch
      ? [
          "branch_manager",
          "branch_submanager",
          "secretary_general",
          "secretariat",
          "accountant",
        ]
      : [],
    committee: canSelectCommittee
      ? ["committee_chairman", "committee_vice_chairman"]
      : [],
  };
});

const selectableLabelTypesMap = computed<
  Record<OrganizationType, UserLabelType[]>
>(() => {
  const canSelectAssociation = isAllLManager.value || isAManager;
  const canSelectBranch = isAllLManager.value || isBManager;
  const canSelectCommittee = isAllLManager.value || isCManager;

  return {
    all: canSelectAssociation
      ? [
          "office",
          "all_manager",
          "all_poster",
          "all_l_manager",
          "u_manager",
          "v_manager",
          "a_manager",
          "a_poster",
          "rule_manager",
          "bcp_manager",
          "i_manager",
          "d_manager",
          "a_t_manager",
        ]
      : [],
    branch: canSelectBranch ? ["c_manager", "c_poster", "c_t_manager"] : [],
    committee: canSelectCommittee
      ? ["b_manager", "b_poster", "b_t_manager"]
      : [],
  };
});

// organizations

const { getOrganizations } = useOrganizations();
const { data: organizations } = getOrganizations();

const associationOrganizationId = computed(() => {
  if (!organizations.value) {
    return undefined;
  }

  return organizations.value.find((o) => !o.branch)?.id;
});

const branchOrganizations = computed(() => {
  if (!organizations.value) {
    return [];
  }

  return organizations.value.filter((o) => !!o.branch);
});

const committeeOrganizations = computed(() => {
  if (!organizations.value) {
    return [];
  }

  return organizations.value.filter((o) => o.committee);
});

const positionTypesByOrganizationType: Record<
  OrganizationType,
  UserPositionType[]
> = {
  branch: [
    "branch_manager",
    "branch_submanager",
    "secretary_general",
    "secretariat",
    "accountant",
  ],
  committee: ["committee_chairman", "committee_vice_chairman"],
  all: ["senior_advisor", "chairman", "vice_chairman", "director", "advisor"],
};

const labelTypesByOrganizationType: Record<OrganizationType, UserLabelType[]> =
  {
    branch: ["c_manager", "c_poster", "c_t_manager"],
    committee: ["b_manager", "b_poster", "c_t_manager"],
    all: [
      "office",
      "all_manager",
      "all_poster",
      "all_l_manager",
      "u_manager",
      "v_manager",
      "a_manager",
      "a_poster",
      "rule_manager",
      "bcp_manager",
      "i_manager",
      "d_manager",
      "a_t_manager",
    ],
  };

watch(branchOrganizations, (brs) => {
  if (brs && brs.length) {
    selectedBranchIds.value = brs.map((b) => b.id);
  }
});

watch(committeeOrganizations, (cos) => {
  if (cos && cos.length) {
    selectedCommitteeIds.value = cos.map((c) => c.id);
  }
});

watch(selectedOrganizationType, () => {
  selectedPositionTypes.value = [];
  selectedLabelTypes.value = [];
  selectedBranchIds.value = [];
  selectedCommitteeIds.value = [];
});

const filteredUsers = computed(() => {
  if (!usersList.value) {
    return [];
  }

  /*
  if (selectedSpecialCases.value.includes("allManager")) {
    return usersList.value.filter((u) =>
      u.userLabels.some((ul) => ul.labelType === "all_manager")
    );
  }

  if (selectedSpecialCases.value.includes("unsubscribed")) {
    return usersList.value.filter((u) => u.unsubscribed);
  }
  */

  return usersList.value;

  const hitUsers = usersList.value.filter((u) => {
    // name
    /*
    const nameIsEmptyOrContainNameStr =
      !searchName.value ||
      (u.lastName + u.firstName).includes(searchName.value) ||
      (u.lastNameKana + u.firstNameKana).includes(searchName.value);
    */

    /*
    const typeIsMatch =
      selectedUserType.value === "normal"
        ? !u.beforeCheckManager && !u.unsubscribedAt
        : selectedUserType.value === "unsubscribed"
        ? !!u.unsubscribedAt
        : u.beforeCheckManager;
    */

    /*
    const specialTypeIncludes =
      selectedUserType.value !== "normal" ||
      selectedUserSpecialTypes.value.includes(u.special ? "special" : "regular");
    */

    /*
    const organizationTypeIsMatch =
      selectedOrganizationType.value === "all"
        ? true
        : selectedOrganizationType.value === "branch"
        ? u.organizations.some((o) => o.branch)
        : u.organizations.some((o) => o.committee);
    */

    /*
    const joinBranch =
      selectedOrganizationType.value !== "branch" ||
      selectedBranchIds.value.length === 0 ||
      u.joinOrganizations.some((o: OrganizationClient) =>
        selectedBranchIds.value.includes(o.id)
      );

    const joinCommittee =
      selectedOrganizationType.value !== "committee" ||
      selectedCommitteeIds.value.length === 0 ||
      u.joinOrganizations.some((o: OrganizationClient) =>
        selectedCommitteeIds.value.includes(o.id)
      );
    */

    /*
    const havePosition =
      selectedPermissionType.value !== "position" ||
      selectedPositionTypes.value.length === 0 ||
      u.userPositions.some((up) =>
        selectedPositionTypes.value.includes(up.positionType)
      );
    */

    /*
    const haveLabel =
      selectedPermissionType.value !== "label" ||
      selectedLabelTypes.value.length === 0 ||
      u.userLabels.some((ul) =>
        selectedLabelTypes.value.includes(ul.labelType)
      );
    */

    // return nameIsEmptyOrContainNameStr;
    // typeIsMatch &&
    // specialTypeIncludes &&
    // organizationTypeIsMatch &&
    // joinBranch &&
    // joinCommittee &&
    // havePosition &&
    // haveLabel
    return true;
  });

  return hitUsers;
});

const currentPageUsers = computed(() => {
  // filter by selectedPerPage, currentPage
  const start = selectedPerPage.value * (currentPage.value - 1);
  const end = start + selectedPerPage.value;
  return filteredUsers.value.slice(start, end);
});

const actualPerPage = computed(() => {
  const v = selectedPerPage.value - filteredUsers.value.length;

  return v > 0 ? selectedPerPage.value : filteredUsers.value.length;
});

// const currentPage = ref(1);

function onPage(event: { page: number }) {
  currentPage.value = event.page + 1;
}

// label form

const { useFormAndErrors } = useZodScheme();
const { form, errors, startValidation } = useFormAndErrors<ManageUserForm>(
  ManageUserCheckScheme,
  {
    userLabels: [],
    userPositions: [],
    organizationMembers: [],
  }
);

const branchLabels = ["c_manager", "c_poster"];
const committeeLabels = ["b_manager", "b_poster"];
const needDepsLabels = [...branchLabels, ...committeeLabels];
const associationDepsLabels = ["a_manager"];

function hasSameLabels(uls: UserLabel[]) {
  // return true when uls has same label
  // same means labelType and dependancyType are same but ignore same index

  return uls.some((ul, idx) => {
    const same = uls.find(
      (u, i) =>
        i !== idx &&
        u.labelType === ul.labelType &&
        u.dependancyType === ul.dependancyType &&
        u.dependancyId === ul.dependancyId
    );

    return !!same;
  });
}

function hasSameOrganizationMembers(oms: OrganizationMember[]) {
  // return true when oms has same organization
  // same means organizationId are same but ignore same index

  return oms.some((om, idx) => {
    const same = oms.find(
      (o, i) => i !== idx && o.organizationId === om.organizationId
    );

    return !!same;
  });
}

const hasSame = computed(() => {
  if (form.userLabels.length === 0 && form.organizationMembers.length === 0) {
    return false;
  }

  return (
    hasSameLabels(form.userLabels) ||
    hasSameOrganizationMembers(form.organizationMembers)
  );
});

watch(selectedUser, (u) => {
  if (!u) {
    return;
  }

  form.special = u.special;
  form.firstName = u.firstName;
  form.lastName = u.lastName;
  form.firstNameKana = u.firstNameKana;
  form.lastNameKana = u.lastNameKana;
  form.email = u.email;
  form.birthday = u.birthday;
  form.phoneNumber = u.phoneNumber;
  form.postcode = u.postcode;
  form.address = u.address;
  form.haveAffiliation = !!u.affiliation;
  form.affiliation = u.affiliation;
  form.affiliationPhoneNumber = u.affiliationPhoneNumber;
  form.affiliationPostcode = u.affiliationPostcode;
  form.affiliationAddress = u.affiliationAddress;
  form.business = u.business;
  form.registrationNumber = u.registrationNumber;
  // userLabelsとuserPositionsで有効な値のみをフィルタリング
  form.userLabels = u.userLabels.filter(
    (ul) => ul.labelType && ul.dependancyId
  );
  form.userPositions = u.userPositions.filter(
    (up) => up.positionType && up.organizationId
  );
  form.organizationMembers = u.organizationMembers
    .filter((om) => om.organizationId)
    .map((om) => ({
      id: om.id,
      organizationId: om.organizationId,
      type: organizationTypeMap.value[om.organizationId] || "all",
    }));
});

watch(form, (f) => {
  // form を watch する場合は、まとめて変更した時の処理を書けるが、
  // 無駄な比較処理が増えるのと過去の値へのアクセスができない問題がある。
  // そのため個別のプロパティでの変更があった時のような処理が書けない

  if (f.firstName && f.firstName.length > 50) {
    form.firstName = f.firstName.slice(0, 50);
  }

  if (f.lastName && f.lastName.length > 50) {
    form.lastName = f.lastName.slice(0, 50);
  }

  if (f.firstName && f.firstName.length > 50) {
    form.firstName = f.firstName.slice(0, 50);
  }

  if (f.firstNameKana && f.firstNameKana.length > 50) {
    form.firstNameKana = gKana(f.firstNameKana.slice(0, 50));
  }

  if (f.lastNameKana && f.lastNameKana.length > 50) {
    form.lastNameKana = gKana(f.lastNameKana.slice(0, 50));
  }

  if (f.postcode) {
    form.postcode = gPostcode(f.postcode);
  }

  if (f.address && f.address.length > 150) {
    form.address = f.address.slice(0, 150);
  }

  if (f.phoneNumber) {
    form.phoneNumber = gPhoneNumber(f.phoneNumber);
  }

  if (f.affiliation && f.affiliation.length > 50) {
    form.affiliation = f.affiliation.slice(0, 50);
  }

  if (f.affiliationPostcode) {
    form.affiliationPostcode = gPostcode(f.affiliationPostcode);
  }

  if (f.affiliationAddress && f.affiliationAddress.length > 150) {
    form.affiliationAddress = f.affiliationAddress.slice(0, 150);
  }

  if (f.affiliationPhoneNumber) {
    form.affiliationPhoneNumber = gPhoneNumber(f.affiliationPhoneNumber);
  }

  if (f.registrationNumber) {
    form.registrationNumber = gRegistrationNumber(f.registrationNumber);
  }

  if (f.business && f.business.length > 50) {
    form.business = f.business.slice(0, 50);
  }
});

startValidation.value = true;

// up

function addPosition(organizationId: number) {
  form.userPositions.push({
    positionType: undefined,
    organizationId,
  });
}

function disabledAddPosition(organizationId: number) {
  if (!organizationId) {
    return true;
  }

  return form.userPositions.some(
    (up) => up.organizationId === organizationId && !up.positionType
  );
}

function deletePosition(idx: number, organizationId: number) {
  /*
  const tmp = [
    ...form.userPositions.filter((up) => up.organizationId === organizationId),
  ];
  tmp.splice(idx, 1);

  form.userPositions = [
    ...tmp,
    ...form.userPositions.filter((up) => up.organizationId !== organizationId),
  ];
  */

  form.userPositions.splice(idx, 1);
}

// ul

function addRole(organizationId: number) {
  form.userLabels.push({
    labelType: undefined,
    dependancyType: "Organization",
    dependancyName: undefined,
    dependancyId: organizationId,
  });
}

function disabledAddRole(organizationId?: number) {
  if (!organizationId) {
    return true;
  }

  return form.userLabels.some(
    (ul) => ul.dependancyId === organizationId && !ul.labelType
  );
}

function deleteRole(idx: number, organizationId: number) {
  /*
  const tmp = [
    ...form.userLabels.filter((ul) => ul.dependancyId === organizationId),
  ];

  tmp.splice(idx, 1);

  form.userLabels = [
    ...tmp,
    ...form.userLabels.filter((ul) => ul.dependancyId !== organizationId),
  ];
  */
  form.userLabels.splice(idx, 1);
}

function updateLabelType(ul: UserLabel, value: string, organizationId: number) {
  ul.dependancyType = "Organization";
  ul.dependancyId = organizationId;
}

// om

const firstBranchOrganization = computed(() => {
  return branchOrganizations.value[0]?.id || 0;
});

const firstCommitteeOrganization = computed(() => {
  return committeeOrganizations.value[0]?.id || 0;
});

function addOrganizationMember(organizationType: OrganizationType) {
  form.organizationMembers.push({
    organizationId: undefined,
    type: organizationType,
  });
}

const disabledAddOrganizationMember = computed(() => {
  return form.organizationMembers.some((om) => !om.organizationId);
});

function deleteOrganizationMember(
  idx: number,
  organizationType: OrganizationType
) {
  let count = 0;
  const targetIdx = form.organizationMembers.findIndex((om) => {
    if (om.type === organizationType) {
      if (count === idx) {
        return true;
      }

      count++;
    }
  });

  form.organizationMembers.splice(targetIdx, 1);
}

async function accept() {
  if (!selectedUser.value) {
    return;
  }

  if (await updateUser(selectedUser.value.id, { beforeCheckManager: false })) {
    window.alert("承認に成功しました。");
    getAllUsersMutate();
    closeDialog();
  } else {
    window.alert("承認に失敗しました。");
  }
}

// 退会処理
async function unsubscribed() {
  if (!selectedUser.value) {
    return;
  }

  if (!window.confirm("このユーザーの退会処理を行います。よろしいですか？")) {
    return;
  }

  if (await updateUser(selectedUser.value.id, { unsubscribed: true })) {
    window.alert("退会に成功しました。");
    getAllUsersMutate();
    closeDialog();
  } else {
    window.alert("退会に失敗しました。");
  }
}

async function cancelUnsubscribed() {
  if (!selectedUser.value) {
    return;
  }

  if (!window.confirm("このユーザーの退会処理をキャンセルしますか？")) {
    return;
  }

  if (await updateUser(selectedUser.value.id, { unsubscribed: false })) {
    window.alert("退会のキャンセルに成功しました。");
    getAllUsersMutate();
    closeDialog();
  } else {
    window.alert("退会のキャンセルに失敗しました。");
  }
}

const cannotSubmit = computed(() => {
  return (
    form.organizationMembers.some((om) => !om.organizationId) ||
    form.userLabels.some((ul) => !ul.labelType)
  );
});

async function submit() {
  if (!selectedUser.value) {
    return;
  }

  // より厳密なフィルタリング - 必要なプロパティが全て存在するもののみ残す
  form.userLabels = form.userLabels.filter(
    (ul) => ul.labelType && ul.dependancyId
  );
  form.userPositions = form.userPositions.filter(
    (up) => up.positionType && up.organizationId
  );
  form.organizationMembers = form.organizationMembers.filter(
    (om) => om.organizationId
  );

  try {
    const prms = ManageUserCheckScheme.parse(form);

    if (await updateUser(selectedUser.value.id, prms)) {
      window.alert("更新に成功しました。");
      getAllUsersMutate();
      closeDialog();
    } else {
      window.alert("更新に失敗しました。");
    }
  } catch (e) {
    alert("入力に問題があります。赤枠の項目を確認して下さい。");
    console.error(e);
  }
}

// csv download

const selectionMode = ref<"multiple" | "single" | undefined>(undefined);

const visibleCsvDialog = ref(false);
const expandCsvRows = ref({});

function startCsvMemberSelect() {
  selectionMode.value = "multiple";
}

function openCsvDialog() {
  visibleCsvDialog.value = true;
}

function closeCsvDialog() {
  visibleCsvDialog.value = false;
}

const selectedCsvInfoOptions = ref<CsvInfoOption[]>([...csvInfoOptions]);

function selectCsvInfo(infoOption: CsvInfoOption) {
  if (selectedCsvInfoOptions.value.includes(infoOption)) {
    selectedCsvInfoOptions.value = selectedCsvInfoOptions.value.filter(
      (i) => i !== infoOption
    );
  } else {
    selectedCsvInfoOptions.value.push(infoOption);
  }
}

// 選択可能な行 (status が "active" のみ)
const selectableItems = computed<CsvInfoOption[]>(() =>
  csvInfoOptions.filter((item) => item.label !== "名前")
);

// すべての選択可能な行が選ばれているか
const allSelected = computed(() => {
  return (
    selectableItems.value.length > 0 &&
    selectableItems.value.every((item) =>
      selectedCsvInfoOptions.value.map((o) => o.value).includes(item.value)
    )
  );
});

// 一部の選択可能な行だけ選ばれているか
const isIndeterminate = computed(() => {
  return (
    !allSelected.value &&
    selectableItems.value.some((item) =>
      selectedCsvInfoOptions.value.includes(item)
    )
  );
});

function toggleSelectAll(event: {
  target: { checked: boolean };
  stopPropagation: () => void;
}) {
  event.stopPropagation();
  if (allSelected.value) {
    // すべて選択解除
    selectedCsvInfoOptions.value = selectedCsvInfoOptions.value.filter(
      (item) => !selectableItems.value.map((i) => i.value).includes(item.value)
    );
  } else {
    // すべて選択 (無効化されていないもののみ)
    selectedCsvInfoOptions.value = [
      ...selectedCsvInfoOptions.value,
      ...selectableItems.value.filter(
        (item) =>
          !selectedCsvInfoOptions.value.map((i) => i.value).includes(item.value)
      ),
    ];
  }
}

async function downloadCsv(allMember?: boolean) {
  try {
    const targetUserIds = selectedUsers.value
      .filter((u) => filteredUsers.value.map((user) => user.id).includes(u.id))
      .map((u) => u.id);

    if (!allMember && !targetUserIds.length) {
      alert("ダウンロードするユーザーをチェックボックスで選択してください");
      return;
    }

    if (!window.confirm("CSV ダウンロードを実行しますか？")) {
      return;
    }

    const response = await getAllUsersCSV(allMember ? [] : targetUserIds, {
      targetPropaties: selectedCsvInfoOptions.value.map((i) => i.value),
    });

    if (!response) {
      console.error("CSVダウンロードに失敗しました");
      return;
    }

    // ダウンロード用のリンクを生成してダウンロードを実行
    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `users-${new Date().toISOString()}.csv`);
    document.body.appendChild(link);
    link.click();

    // リソースを解放
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("CSVダウンロードに失敗しました:", error);
  }
}
</script>

<style scoped></style>
